export default function ProgramsSection() {
  const programs = [
    {
      title: 'Trải nghiệm & khám phá',
      subtitle: 'ESAP Robotics Discovery',
      level: 'Cấp 0',
      duration: '2 tháng (16 buổi)',
      image: 'https://public.readdy.ai/ai/img_res/3bfcdb46192fb6ad1e53e9b0253bf2f7.jpg',
      levelColor: 'from-pink-500 to-pink-600',
      contents: [
        'Làm quen với robot và lập trình cơ bản',
        'Xây dựng mô hình đơn giản',
        'Khám phá cảm biến và chuyển động',
        'Dự án: Robot đơn giản, xe tự động'
      ],
      outcome: 'Khơi gợi hứng thú với công nghệ, tư duy sáng tạo và khả năng giải quyết vấn đề'
    },
    {
      title: 'Cơ bản',
      subtitle: 'ESAP Scratch Robotics – Foundation',
      level: 'Cấp 1',
      duration: '2 tháng (16 buổi)',
      image: 'https://public.readdy.ai/ai/img_res/8262a01f7d3e871f5e6bfa88dc2511a9.jpg',
      levelColor: 'from-blue-500 to-blue-600',
      contents: [
        'Lập trình Scratch nâng cao',
        'Cơ học robot và động cơ',
        'Cảm biến cơ bản (ánh sáng, âm thanh)',
        'Dự án: Robot dò đường, tránh vật cản'
      ],
      outcome: 'Nắm vững lập trình block-based, hiểu nguyên lý hoạt động robot cơ bản'
    },
    {
      title: 'Thông minh',
      subtitle: 'ESAP Scratch Robotics – Smart Control',
      level: 'Cấp 2',
      duration: '2 tháng (16 buổi)',
      image: 'https://readdy.ai/api/search-image?query=Middle%20school%20students%20programming%20smart%20robots%20with%20advanced%20sensors%20and%20control%20systems%2C%20teenagers%20working%20on%20intelligent%20robotics%20projects%20with%20automated%20control%20mechanisms%20in%20technology%20learning%20lab&width=600&height=400&seq=program-level2-smart&orientation=landscape',
      levelColor: 'from-green-500 to-green-600',
      contents: [
        'Điều khiển thông minh và tự động hóa',
        'Cảm biến nâng cao (siêu âm, hồng ngoại)',
        'Thuật toán điều khiển cơ bản',
        'Dự án: Robot thông minh, xe tự hành'
      ],
      outcome: 'Phát triển tư duy logic, kỹ năng lập trình điều khiển và tự động hóa'
    },
    {
      title: 'Thuật toán - Lập trình',
      subtitle: 'ESAP Scratch Robotics – Logic & Automation',
      level: 'Cấp 3',
      duration: '3 tháng (24 buổi)',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20students%20coding%20complex%20algorithms%20for%20robotics%20automation%2C%20teenagers%20programming%20logic%20systems%20and%20automated%20sequences%20with%20advanced%20block-based%20coding%20in%20professional%20robotics%20lab%20environment&width=600&height=400&seq=program-level3-logic&orientation=landscape',
      levelColor: 'from-orange-500 to-orange-600',
      contents: [
        'Thuật toán và logic lập trình',
        'Tự động hóa quy trình phức tạp',
        'Xử lý dữ liệu từ nhiều cảm biến',
        'Dự án: Robot tự động hóa, hệ thống thông minh'
      ],
      outcome: 'Thành thạo thuật toán, lập trình logic và xây dựng hệ thống tự động'
    },
    {
      title: 'Ứng dụng IoT',
      subtitle: 'ESAP Scratch Robotics – IoT & Cloud',
      level: 'Cấp 4',
      duration: '3 tháng (24 buổi)',
      image: 'https://readdy.ai/api/search-image?query=Students%20developing%20IoT%20robotics%20applications%20with%20cloud%20connectivity%20and%20wireless%20sensors%2C%20teenagers%20programming%20smart%20home%20automation%20and%20internet-connected%20robots%20with%20ESP32%20microcontrollers%20in%20modern%20technology%20lab&width=600&height=400&seq=program-level4-iot&orientation=landscape',
      levelColor: 'from-teal-500 to-teal-600',
      contents: [
        'Lập trình Python cơ bản',
        'ESP32 và IoT',
        'Kết nối mạng và điều khiển từ xa',
        'Dự án: Smart Home, Robot IoT'
      ],
      outcome: 'Ứng dụng IoT thực tế, kết nối thiết bị thông minh và điều khiển qua mạng'
    },
    {
      title: 'Ứng dụng - Chế tạo Robot',
      subtitle: 'ESAP Robo Automation',
      level: 'Cấp 5',
      duration: '6 tháng (48 buổi)',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20students%20building%20professional%20autonomous%20robots%20with%20AI%20and%20automation%20systems%2C%20college-level%20robotics%20engineering%20with%20custom%20robot%20fabrication%20and%20advanced%20programming%20in%20professional%20workshop%20environment&width=600&height=400&seq=program-level5-automation&orientation=landscape',
      levelColor: 'from-purple-500 to-purple-600',
      contents: [
        'Lập trình C/C++, Python nâng cao',
        'Thiết kế và chế tạo robot',
        'AI cơ bản và Computer Vision',
        'Dự án: Robot tự động hóa, ứng dụng AI'
      ],
      outcome: 'Chế tạo robot hoàn chỉnh, ứng dụng AI và chuẩn bị cho nghề nghiệp'
    }
  ];

  return (
    <section id="programs" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Chương trình <span className="text-orange-600">Đào tạo</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Lộ trình học tập 6 cấp độ được thiết kế bài bản từ khám phá đến chuyên sâu, phù hợp với mọi lứa tuổi và trình độ, đảm bảo học viên phát triển toàn diện
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="relative h-56 overflow-hidden">
                <img 
                  alt={program.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src={program.image}
                />
                <div className={`absolute top-4 left-4 bg-gradient-to-r ${program.levelColor} text-white px-4 py-2 rounded-full font-semibold text-sm`}>
                  {program.level}
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{program.title}</h3>
                <p className="text-sm text-orange-600 font-semibold mb-3">{program.subtitle}</p>
                <div className="flex items-center text-gray-600 mb-6">
                  <i className="ri-time-line mr-2 text-orange-600"></i>
                  <span className="text-sm">{program.duration}</span>
                </div>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <i className="ri-file-list-3-line mr-2 text-orange-600"></i>
                    Nội dung chính:
                  </h4>
                  <ul className="space-y-2">
                    {program.contents.map((content, idx) => (
                      <li key={idx} className="flex items-start text-sm text-gray-600">
                        <i className="ri-checkbox-circle-fill text-orange-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>{content}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-orange-50 rounded-lg p-4 mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2 flex items-center text-sm">
                    <i className="ri-trophy-line mr-2 text-orange-600"></i>
                    Đầu ra:
                  </h4>
                  <p className="text-sm text-gray-700">{program.outcome}</p>
                </div>

                <button className="whitespace-nowrap w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all cursor-pointer">
                  Đăng ký ngay
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}